'use client'

import React from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

interface ContentSummaryBoxProps {
  contentSummary: string
}

const ContentSummaryBox: React.FC<ContentSummaryBoxProps> = ({ contentSummary }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey['300'],
        mb: 2,
        borderRadius: 1,
        px: 2,
        py: 1.5,
      }}
    >
      <Box component="p" sx={{ fontStyle: 'italic', color: 'text.secondary', margin: 0 }}>
        {contentSummary}
      </Box>
    </Box>
  )
}

export default ContentSummaryBox
